import EmptyPage from '../../empty-page/emptyPage';

const OrgGuidInsights = () => {
    return <EmptyPage />;
};

export default OrgGuidInsights;
